import React from 'react';

import { AiOutlinePlayCircle } from 'react-icons/ai';
import ModalVideo from 'react-modal-video';

import { ModalImage } from '../../FormElements';

export const RenderSectionTitle = ({
  showVideoModal,
  setShowVideoModal,
  propertyFeature,
  isMainApplicant,
}) => {
  const demoLink = propertyFeature?.demoLink;
  const title = isMainApplicant ? propertyFeature?.title : 'We need you to jump in!';
  return propertyFeature ? (
    <h1 className="title">
      {title}
      {demoLink && (
        <span className="demoLink" onClick={() => setShowVideoModal(true)}>
          <AiOutlinePlayCircle /> Help
        </span>
      )}
      {demoLink?.endsWith('mp4') ? (
        <ModalVideo
          channel="custom"
          isOpen={showVideoModal}
          url={demoLink}
          onClose={() => setShowVideoModal(false)}
        />
      ) : (
        <ModalImage
          isOpen={showVideoModal}
          src={demoLink}
          onClose={() => setShowVideoModal(false)}
        />
      )}
    </h1>
  ) : (
    ''
  );
};
